// @flow
import React, { Component } from 'react'
import './App.css'

// PlayerRenderer is provided by packages/vizor-react-vr/vr/playerRenderer.js
// included using a <script> tag.
declare var PlayerRenderer: Object

const defaultConfig = {
  cdnRoot: process.env.REACT_APP_CDN_ROOT,
  assetsHost: process.env.REACT_APP_ASSETS_HOST,
  assetsPort: process.env.REACT_APP_ASSETS_PORT || '3300',
  webSocketHost: process.env.REACT_APP_WS_HOST,
  webSocketPort: process.env.REACT_APP_WS_PORT || '3300',
  useSecureWebSocket: process.env.REACT_APP_WS_PORT === '443',
  gitCommit: process.env.REACT_APP_GIT_COMMIT || '',
}

type Props = {
  file: Object
}

class App extends Component {
  props: Props

  playerRef = (node: HTMLElement) => { // eslint-disable-line class-methods-use-this
    PlayerRenderer.init(node, defaultConfig, { file: this.props.file })
  }

  render() {
    return (
      <div className="App" ref={this.playerRef} />
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js